import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Footer from '../components/Footer';

const LegalPage = () => {
    return (
        <div className="legal-page">
            <div className="container" style={{ minHeight: '100vh', paddingTop: '4rem', paddingBottom: '4rem' }}>
                <div className="pomodoro-nav" style={{ marginBottom: '2rem' }}>
                    <Link to="/" className="back-link">
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </Link>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <h1 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>Yasal Bilgilendirme</h1>

                    <div className="legal-content" style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <section id="privacy" className="legal-section" style={{ marginBottom: '4rem' }}>
                            <h2 className="section-title-small">Gizlilik Politikası</h2>
                            <div className="legal-text" style={{ color: 'var(--muted)', lineHeight: '1.6' }}>
                                <p style={{ marginBottom: '1rem' }}>
                                    <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
                                </p>
                                <p style={{ marginBottom: '1rem' }}>
                                    Soruly ("biz", "bizim" veya "şirketimiz") olarak gizliliğinize önem veriyoruz. Bu Gizlilik Politikası, mobil uygulamamızı
                                    kullandığınızda bilgilerinizin nasıl toplandığını, kullanıldığını ve paylaşıldığını açıklar.
                                </p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Toplanan Bilgiler:</strong> Uygulamamızın temel fonksiyonlarını sağlamak için cihazınızda yerel olarak veri tutabiliriz. Kişisel verileriniz sunucularımızda saklanmaz.</li>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Kullanım Amacı:</strong> Hizmetlerimizi iyileştirmek, hataları gidermek ve size daha iyi bir deneyim sunmak için anonim kullanım verileri toplayabiliriz.</li>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Veri Güvenliği:</strong> Verilerinizin güvenliğini sağlamak için endüstri standardı güvenlik önlemleri alıyoruz.</li>
                                </ul>
                                <p>
                                    Herhangi bir sorunuz varsa, lütfen bizimle iletişime geçin.
                                </p>
                            </div>
                        </section>

                        <section id="terms" className="legal-section">
                            <h2 className="section-title-small">Kullanım Koşulları</h2>
                            <div className="legal-text" style={{ color: 'var(--muted)', lineHeight: '1.6' }}>
                                <p style={{ marginBottom: '1rem' }}>
                                    Lütfen Soruly uygulamasını kullanmadan önce bu Kullanım Koşullarını dikkatlice okuyun.
                                </p>
                                <ol style={{ listStyleType: 'decimal', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Kabul:</strong> Uygulamayı indirerek veya kullanarak, bu koşulları kabul etmiş olursunuz.</li>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Lisans:</strong> Soruly, uygulamayı kişisel ve ticari olmayan kullanımınız için size kısıtlı bir lisans verir.</li>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Sorumluluk Reddi:</strong> Uygulama "olduğu gibi" sunulur. Kesintisiz veya hatasız çalışacağını garanti etmiyoruz.</li>
                                    <li style={{ marginBottom: '0.5rem' }}><strong>Değişiklikler:</strong> Bu koşulları zaman zaman güncelleme hakkımız saklıdır.</li>
                                </ol>
                            </div>
                        </section>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default LegalPage;
